import React, { useState , useEffect} from 'react'
import Trusted from '../HomeMain/Trusted/Main'
import { Link } from 'react-router-dom'
import Bredcrumb from '../Bredcrumb/Main'
import BGImg from "../../assets/images/bread_crumb_bg.png"
import BGImg1 from "../../assets/images/bread_crumb_bg_one.png"
import BGImg2 from "../../assets/images/bread_crumb_bg_two.png"

const Main = ({brdcum}) => {
    const [ytShow , setytShow] = useState (false)

  return (
    <>       
       {brdcum.b1 && 
        <Bredcrumb 
        no={1}
        title="About Us" 
        tag="About us" 
        bgimg={BGImg}/>}

        {brdcum.b2 && 
        <Bredcrumb 
        no={2}
        title="About Us" 
        tag="About us" 
        bgimg={BGImg1}/>}

        {brdcum.b5 && 
        <Bredcrumb 
        no={5}
        title="About Us" 
        tag="About us" 
        bgimg={BGImg}/>}


        {brdcum.b3 && 
        <Bredcrumb 
        no={3}
        title="About Us" 
        tag="About us" />}

        {brdcum.b4 && 
        <Bredcrumb 
        no={4}
        title="About Us" 
        tag="About us" 
        bgimg={BGImg2}/>}

        <section className="row_am app_solution_section">
            <div className="container">
                <div className="row">
                    <div className="col-lg-6">
                        <div className="app_text">
                        <div className="section_title"  data-aos-duration="1500" data-aos-delay="100">
                            <h2><span>Providing innovative app solution</span> saving upto 20% overall cost per project.</h2>
                        </div>
                        <p  data-aos-duration="1500">
                            FNVi delivering Innovative Digital Workflow & Data Management Software, turning Data into business intelligence and harnessing knowledge that has impact. Accord is a next Generation Digital Workflow, Logistics & Project Management system that brings together all aspects of enhanced workflow management, offering Real Intelligence for engineering excellence. The Project Delivery Management Software provides features to effectively assign, plan and execute work to maintain resource and asset integrity. It enables companies to efficiently bring new facilities on-stream faster and optimise their data management for a higher return on investment, resulting in cost savings in excess of 25% of anticipated project personnel spend. Used by both owner/operators and contractors alike to effectively monitor, manage and control a plethora of project data and drawings from any location. Infinitely customisable dashboard views to facilitate, plan and share work in a coordinated manner.
                        </p>
                        <p  data-aos-duration="1500">
                            Our system is profile and job function driven. The system knows who you are, your job function, area of responsibility and your work focus. 36% of organisations do not have the tools to extract information from their data. FNVi Accord does this for you, we track the tasks not the paper, increasing efficiency and ROI. Our cutting edge disruptive technology dramatically improves project visibility and communications to all project team members throughout the full project cycle, allowing easy exchange of information whilst integrating with any commercial ERP software systems on the market such as SAP, Maximo, Dynamics etc.


                        </p>
                        </div>
                    </div>
                    <div className="col-lg-6">
                        <div className="app_images"  data-aos-duration="1500">
                        <ul>
                            <li><img src="/assets/images/abt_01.png" alt="" /></li>
                            <li>
                            <a data-url="#" onClick = {() => setytShow(true)}  className="popup-youtube play-button"
                                data-toggle="modal"
                                data-target="#myModal" title="About Video">
                                <img src="/assets/images/abt_02.png" alt="" />
                                <div className="waves-block">
                                <div className="waves wave-1"></div>
                                <div className="waves wave-2"></div>
                                <div className="waves wave-3"></div>
                                </div>
                                <span className="play_icon"><img src="/assets/images/play_black.png" alt="image"/></span>
                            </a>
                            </li>
                            <li><img src="/assets/images/abt_03.png" alt="" /></li>
                        </ul>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section className="row_am why_we_section" >
            <div className="why_inner">
                <div className="container">
                <div className="section_title"  data-aos-duration="1500" data-aos-delay="100">
                    <h2><span>Why we are different</span> from others!</h2>
                    <p>We're not just an item tracker. We're a user profile driver, multi project, multi lingual, handover driven, workpack deliverable, item, equipment, document scheduling tracker all bundled into one.</p>
                </div>
                <div className="row">
                    <div className="col-md-6 col-lg-3">
                    <div className="why_box"  data-aos-duration="1500" data-aos-delay="100">
                        <div className="icon">
                        <img src="/assets/images/secure.png" alt="image"/>
                        </div>
                        <div className="text">
                        <h3>Unlimited Item Tracking</h3>
                        <p>
                            We use expandable databases which means your data can grow as big as your project does. Track and upload as many items, equipment, documents, punches, technical queries, site queries, safety queries, non-comformance reports... Whatever it is, make as many as you like.
                        </p></div>
                    </div>
                    </div>
                    <div className="col-md-6 col-lg-3">
                    <div className="why_box"  data-aos-duration="1500" data-aos-delay="200">
                        <div className="icon">
                        <img src="/assets/images/abt_functional.png" alt="image"/>
                        </div>
                        <div className="text">
                        <h3>Digital Workpacks</h3>
                            <p>
                                The days of lugging around huge paper workpacks is over. Accord offers full digital workpacks which include; Inspection test record, full tag/item details, equipment details, loop data, inspection test records, inspection certificates, documentation associated with the item all in one digital pdf at the click of a button.
                            </p>
                        </div>
                    </div>
                    </div>
                    <div className="col-md-6 col-lg-3">
                    <div className="why_box"  data-aos-duration="1500" data-aos-delay="300">
                        <div className="icon">
                        <img src="/assets/images/communication.png" alt="image"/>
                        </div>
                        <div className="text">
                        <h3>Reporting</h3>
                        <p>
                            Accord offers the latest reporting technology, dynamically on any device. You have access to all of your data, bring those silo's of repositories into one consolidated place to manage and report on your date.
                        </p>
                        </div>
                    </div>
                    </div>
                    <div className="col-md-6 col-lg-3">
                    <div className="why_box"  data-aos-duration="1500" data-aos-delay="400">
                        <div className="icon">
                        <img src="/assets/images/abt_support.png" alt="image"/>
                        </div>
                        <div className="text">
                        <h3>LUN's / Handovers</h3>
                        <p>
                            Accord provides the handy Liven Up Notice module which allows you to create and produce LUN's at the click of a button.<br/><br/>
                            Handovers drive a crucial play within Accord, easily create and certify handovers with digital signatures using Accords Handover and Handover Certification Module.
                        </p>
                        </div>
                    </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-6 col-lg-3">
                    <div className="why_box"  data-aos-duration="1500" data-aos-delay="100">
                        <div className="icon">
                        <img src="/assets/images/secure.png" alt="image"/>
                        </div>
                        <div className="text">
                        <h3>Secure code</h3>
                        <p>We use the latest technology to make sure your data is protected. We even offer local/on-site storage solutions if you prefer or you're restricted by confidential agreements.                     </p>
                        </div>
                    </div>
                    </div>
                    <div className="col-md-6 col-lg-3">
                    <div className="why_box"  data-aos-duration="1500" data-aos-delay="200">
                        <div className="icon">
                        <img src="/assets/images/abt_functional.png" alt="image"/>
                        </div>
                        <div className="text">
                        <h3>Fully functional</h3>
                        <p>Create a new company, add a project, import your data and start utilizing Accords fully function features within <strong>minutes</strong>.</p>
                        </div>
                    </div>
                    </div>
                    <div className="col-md-6 col-lg-3">
                    <div className="why_box"  data-aos-duration="1500" data-aos-delay="300">
                        <div className="icon">
                        <img src="/assets/images/communication.png" alt="image"/>
                        </div>
                        <div className="text">
                        <h3>Real-time communication</h3>
                        <p>Accord provides real-time web communications, talk to your engineers on Accord using Voice, Video and Screenshare. No third party applications required!!
                        </p>
                        </div>
                    </div>
                    </div>
                    <div className="col-md-6 col-lg-3">
                    <div className="why_box"  data-aos-duration="1500" data-aos-delay="400">
                        <div className="icon">
                        <img src="/assets/images/abt_support.png" alt="image"/>
                        </div>
                        <div className="text">
                        <h3>24-7 Support</h3>
                        <p>Ran into a problem? We offer have 24-7 / 365 support with a turn around of 2-3 hours for bug fixes and 2-3 days for functional changes/integration.</p>
                        </div>
                    </div>
                    </div>
                </div>
                </div>
            </div>
        </section>
        <section className="row_am about_app_section about_page_sectino">
            <div className="container">
                <div className="row">
                    <div className="col-lg-6">
                        <div className="abt_img"  data-aos-duration="1500">
                            <img src="/assets/images/about_main.png" alt="image"/>
                        </div>
                    </div>
                    <div className="col-lg-6">
                        <div className="about_text">
                        <div className="section_title"  data-aos-duration="1500" data-aos-delay="100">
                            <h2> <span>We focus on quality</span> driven services that can save you upto 20% on your project</h2>
                            <p>
                            Our previous clients have seen savings of upto 20% per project by using Accords multi-functional advanced features. Allowing multi projects to be driven from a single application with easy to use UI and advanced reports at your fingertips.
                            </p>
                        </div>
                        <ul className="app_statstic" id="counter"  data-aos-duration="1500">
                            <li>
                            <div className="icon">
                                <img src="/assets/images/download.png" alt="image" />
                            </div>
                            <div className="text">
                                <p><span className="counter-value" data-count="22">22</span><span>M+</span></p>
                                <p>Inspections Complete</p>
                            </div>
                            </li>
                            <li>
                            <div className="icon">
                                <img src="/assets/images/followers.png" alt="image" />
                            </div>
                            <div className="text">
                                <p><span className="counter-value" data-count="08">£8</span><span>M+</span></p>
                                <p>Savings</p>
                            </div>
                            </li>
                            <li>
                            <div className="icon">
                                <img src="/assets/images/reviews.png" alt="image" />
                            </div>
                            <div className="text">
                                <p><span className="counter-value" data-count="19">19</span><span>+</span></p>
                                <p>Successful Projects</p>
                            </div>
                            </li>
                            <li>
                            <div className="icon">
                                <img src="/assets/images/countries.png" alt="image" />
                            </div>
                            <div className="text">
                                <p><span className="counter-value" data-count="150">0</span><span>+</span></p>
                                <p>Countries</p>
                            </div>
                            </li>
                        </ul>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section className="row_am experts_team_section">
            <div className="container">
                <div className="section_title"  data-aos-duration="1500" data-aos-delay="100">
                    <h2> Meet our <span> experts </span></h2>
                    <p>
                        With over 60 years within the commercial construction industry.
                    </p>
                </div>
                <div className="row">
                    <div className="col-md-6 col-lg-3"   data-aos-duration="1500" data-aos-delay="100">
                        <div className="experts_box">
                        <img src="https://fnvi.co.uk/wp-content/uploads/2021/11/shutterstock_image-2021-11-28T205423.024-400x400.jpg" alt="image"/>
                        <div className="text">
                            <h3>Danny McGlade</h3>
                            <span>Co-Founder</span>
                            <ul className="social_media">
                            <li><Link to="#"><i className="icofont-facebook"></i></Link></li>
                            <li><Link to="#"><i className="icofont-twitter"></i></Link></li>
                            <li><Link to="#"><i className="icofont-instagram"></i></Link></li>
                            </ul>
                        </div>
                        </div>
                    </div>
                    <div className="col-md-6 col-lg-3"   data-aos-duration="1500" data-aos-delay="200">
                        <div className="experts_box">
                        <img src="https://ca.slack-edge.com/T5DAB4XMF-U5EJTKHJ8-79a8d2195a44-512" alt="image"/>
                        <div className="text">
                            <h3>Geoff Morgan</h3>
                            <span>CEO & Co-Founder</span>
                            <ul className="social_media">
                            <li><Link to="#"><i className="icofont-facebook"></i></Link></li>
                            <li><Link to="#"><i className="icofont-twitter"></i></Link></li>
                            <li><Link to="#"><i className="icofont-instagram"></i></Link></li>
                            </ul>
                        </div>
                        </div>
                    </div>
                    <div className="col-md-6 col-lg-3"   data-aos-duration="1500" data-aos-delay="200">
                        <div className="experts_box">
                        <img src="https://media.licdn.com/dms/image/C5603AQEQ08Ty1r5hqg/profile-displayphoto-shrink_800_800/0/1516814473326?e=1698883200&v=beta&t=7XbOspDSbxXYwVmmRjvw2SMMaVUshCJG1SWw43uDTCs" alt="image"/>
                        <div className="text">
                            <h3>Gareth Knight</h3>
                            <span>Sixfold Advisor</span>
                            <ul className="social_media">
                            <li><Link to="#"><i className="icofont-facebook"></i></Link></li>
                            <li><Link to="#"><i className="icofont-twitter"></i></Link></li>
                            <li><Link to="#"><i className="icofont-instagram"></i></Link></li>
                            </ul>
                        </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section className="row_am query_section">
            <div className="query_inner"  data-aos-duration="1500">
                <div className="container">
                    <span className="banner_shape1"> <img src="/assets/images/banner-shape1.png" alt="image" /> </span>
                    <span className="banner_shape2"> <img src="/assets/images/banner-shape2.png" alt="image" /> </span>
                    <span className="banner_shape3"> <img src="/assets/images/banner-shape3.png" alt="image" /> </span>
                
                    <div className="section_title">
                        <h2>Have a query?</h2>
                        <p>Give us a call or click the button below to leave us a message. <br/> We'll get back to you within 24 hours (usually hours).</p>
                    </div>
                    <Link to="/contact" className="btn white_btn">CONTACT US NOW</Link>
                </div>
            </div>
        </section>
        <Trusted />
        
        {ytShow &&
        <>
        <div className="modal fade youtube-video show" id="myModal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-modal="true" style={{paddingRight: "17px", display: "block"}}>
            <div className="modal-dialog" role="document">
                <div className="modal-content">
                <button id="close-video" type="button" className="button btn btn-default text-right" data-dismiss="modal">
                    <i className="icofont-close-line-circled" onClick={() => setytShow(false)}></i>
                </button>
                    <div className="modal-body">
                        <div id="video-container" className="video-container">
                            <iframe id="youtubevideo" src="https://www.youtube.com/embed/tgbNymZ7vqY?autoplay=1&amp;mute=1" width="640" height="360" frameborder="0" allowfullscreen=""></iframe>
                        </div>        
                    </div>
                    <div className="modal-footer">
                    </div>
                </div> 
            </div>
        </div>
        <div className="purple_backdrop"></div>
        </>}
    </>
    
  )
}

export default Main